module.exports = Object.freeze({
    admin: 100,
    gerente_nomina: 4,
    nominista: 3,
    user: 1,
  });
  